import { getCurrentLanguage, getDefaultLanguage } from '$features/init/language'

export const getResourceUrl = (resource, size = 'full') => {
  return resource && resource.versions && resource.versions[size] && resource.versions[size].url
}

export const getResourceWithLanguage = (
  resource,
  language = getCurrentLanguage(),
  fallbackLanguage = getDefaultLanguage()
) => {
  if (!resource) return null

  if (resource[language]) {
    return resource[language]
  }

  if (resource[fallbackLanguage]) {
    return resource[fallbackLanguage]
  }

  return Object.values(resource).find(value => value !== '')
}
